import React, { useRef, useEffect } from "react";
import { InputLabel, MenuItem, Select, Stack } from "@mui/material";

function SelectComponent({
  label,
  fontFamily,
  fontWeight,
  colorLabel,
  options,
  valueSelect = "name",
  value = "",
  defaultValue = "",
  textColor,
  fontSizeInput,
  fontSize,
  borderColor,
  backgroundColor = "transparent",
  onChange = () => {},
  width,
}) {
  const selectRef = useRef(null);

  useEffect(() => {
    if (selectRef.current) {
      selectRef.current.style.width = "auto";
    }

    if (!value && defaultValue) {
      onChange({ target: { value: defaultValue } });
    }
  }, [value, defaultValue, onChange]);

  return (
    <Stack>
      <InputLabel
        sx={{
          color: colorLabel,
          fontWeight: fontWeight,
          fontFamily: fontFamily,
          fontSize: fontSizeInput,
        }}
      >
        {label}
      </InputLabel>
      <Select
        ref={selectRef}
        sx={{
          width: width || "100%", // ✅ aquí es donde debe ir
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
          },
          "& .MuiSelect-select": {
            backgroundColor: backgroundColor,
            paddingTop: "6px",
            paddingBottom: "4px",
            minHeight: "auto",
          },
          "& .MuiOutlinedInput-root": {
            padding: "0px 14px",
            minHeight: "32px",
          },
          "& .MuiSelect-root": {
            height: "auto",
            width: width || "100%",
            color: textColor || "white",
            fontSize: fontSize || "inherit",
          },
          "& .MuiInputLabel-root": {
            color: textColor || "white",
            fontSize: fontSize || "inherit",
          },
          "& .MuiInputBase-input": {
            color: textColor || "gray",
            fontSize: fontSize || "14px",
            fontFamily: "Raleway, sans-serif",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
          },
        }}
        value={value}
        onChange={onChange}
      >
        {options ? (
          options.map((option) => (
            <MenuItem key={`${option._id}`} value={option[valueSelect]}>
              {option.name}
            </MenuItem>
          ))
        ) : (
          <></>
        )}
      </Select>
    </Stack>
  );
}

export default SelectComponent;
